import { scopedChannelApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ChannelApiResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { ReadRequestOptions } from '../../requestOptions';
import type { ExpansionRow } from './types';

const validate = (runId: number, subscriptionId: number, productId: number) => {
  if (!runId || runId < 1) {
    throw new Error('Valid run ID is required');
  }
  if (!subscriptionId || subscriptionId < 1) {
    throw new Error('Valid subscription ID is required');
  }
  if (!productId || productId < 1) {
    throw new Error('Valid product ID is required');
  }
};

type RequestParams = {
  runId: number;
  /**
   * Any subscription of the organization — the API authorises the caller against it and scopes
   * every read by organization, never by this id.
   */
  subscriptionId: number;
  productId: number;
};

export type GetRunRowsResponse = {
  data: ExpansionRow[];
};

export const getRunRows = async (
  scope: RequestScope,
  { runId, subscriptionId, productId }: RequestParams,
  options: ReadRequestOptions
): Promise<ChannelApiResponse<GetRunRowsResponse>> => {
  try {
    validate(runId, subscriptionId, productId);

    const result = await scopedChannelApi(scope).get<GetRunRowsResponse>(`atts/expansion/runs/${runId}/rows`, {
      ...options,
      headers: {
        'x-astur-subscription-id': subscriptionId.toString(),
      },
      params: {
        product_id: productId,
      },
    });

    return {
      data: result.data,
      status: result.status,
    };
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
